
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/legal",
      function () {
        return require("private-next-pages/solutions/legal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/legal"])
      });
    }
  